import {ApiVersion, Configuration} from '../app/core/configuration/configuration.types';

export const environment: Configuration = {
    authSettings: {
        baseUrl: 'https://v5dev-api.edoc.us/api/v1',
        loginUrl: 'authentication/login',
        refreshUrl: 'authentication/refresh',
        logoutUrl: 'authentication/logout',
    },
    apiSettings: {
        baseUrl: 'https://v5dev-api.edoc.us/api',
        version: ApiVersion.V1
    },
    turnstileSettings: {
        siteKey: '1x00000000000000000000AA',
        cloudflareBaseUrl: 'https://challenges.cloudflare.com/turnstile/v0/api.js'
    },
    production: false
};
